const EMPTY = Object.freeze({});
const cache = new Map();

const toCamel = (prop) => prop.replace(/-([a-z])/g, (_, c) => c.toUpperCase());

// Split on top-level semicolons only, so declarations like
// `background: url(a;b)` or `content: ";"` survive intact.
function declarations(css) {
  const out = [];
  let start = 0;
  let depth = 0;
  let quote = '';
  for (let i = 0; i < css.length; i++) {
    const c = css[i];
    if (quote) {
      if (c === '\\') i++;
      else if (c === quote) quote = '';
    } else if (c === '"' || c === "'") quote = c;
    else if (c === '(') depth++;
    else if (c === ')') depth = Math.max(0, depth - 1);
    else if (c === ';' && depth === 0) {
      out.push(css.slice(start, i));
      start = i + 1;
    }
  }
  out.push(css.slice(start));
  return out;
}

/**
 * Turn a CSS declaration string into a React style object.
 *
 * The design tooling this page came from expressed every style as a CSS string,
 * and keeping that form makes the markup diffable against the original export.
 * Results are memoised by string, so repeated renders reuse one frozen object
 * and React sees a stable reference.
 */
export function s(css) {
  if (!css) return EMPTY;
  if (typeof css === 'object') return css;

  const hit = cache.get(css);
  if (hit) return hit;

  const style = {};
  for (const decl of declarations(css)) {
    const i = decl.indexOf(':');
    if (i < 0) continue;
    const prop = decl.slice(0, i).trim();
    if (!prop) continue;
    // Custom properties are case-sensitive and must not be camelised.
    style[prop.startsWith('--') ? prop : toCamel(prop)] = decl.slice(i + 1).trim();
  }

  const frozen = Object.freeze(style);
  cache.set(css, frozen);
  return frozen;
}
